import { memo } from "react";
import { useTranslation } from "react-i18next";
import Input from "../../Components/Input";
import EmailInput from "../../Components/EmailInput";
import CountryCode from "../../Components/CountryCode";
import ImageUploader from "../../Components/ImageUploader";

const UserDetails = memo(
  ({
    formData,
    userRole,
    phoneHasError,
    termsHasError,
    termsIsChecked,
    showPhoneVerificationError,
    showEmailVerificationError,
    handleInputChange,
    handlePhoneInputChange,
    handleCheckboxChange,
    handleImageUpload,
    setEmailNeedsVerification,
    setMobileNeedsVerification,
    emailNeedsVerification,
    mobileNeedsVerification,
  }) => {
    const { t } = useTranslation();

    return (
      <>
        <section>
          <ImageUploader
            defaultImage={formData.profileUrl}
            onUpload={handleImageUpload}
          />
          <div>
            <Input
              label={t("userProfile.input_name_label")}
              name="fullName"
              value={formData.fullName || ""}
              onChange={handleInputChange}
              required
            />
          </div>
        </section>
        <section>
          <h4>{t("userProfile.section_contact_header")}</h4>
          <div>
            <EmailInput
              name="contactEmail"
              email={formData.contactEmail || ""}
              onChange={handleInputChange}
              required
              showStatusIcon
              needsVerification={emailNeedsVerification}
              setEmailNeedsVerification={setEmailNeedsVerification}
              hasError={showEmailVerificationError}
              errorText={
                showEmailVerificationError
                  ? t("error_email_verification_needed")
                  : ""
              }
            />
            <CountryCode
              phone={formData.phoneNumber || ""}
              changePhone={handlePhoneInputChange}
              needsVerification={mobileNeedsVerification}
              setMobileNeedsVerification={setMobileNeedsVerification}
              hasError={phoneHasError || showPhoneVerificationError}
              errorMsg={
                showPhoneVerificationError
                  ? t("error_phone_verification_needed")
                  : ""
              }
              showStatusIcon
            />
          </div>
        </section>
        {userRole === "Provider" && (
          <section>
            <h4>{t("userProfile.section_other_header")}</h4>

            <Input
              label={t("userProfile.input_dueDate_label")}
              type="wholeNumber"
              name="duePeriod"
              value={formData.duePeriod || ""}
              onChange={handleInputChange}
              required
            />
          </section>
        )}
        {!formData.termsAccepted && (
          <section>
            <div
              className={`checkbox-container ${termsHasError ? "error" : ""}`}
            >
              <label>
                <input
                  id="consent-checkbox"
                  type="checkbox"
                  checked={termsIsChecked}
                  onChange={handleCheckboxChange}
                />
                <span>
                  {t("userProfile.agree_terms")}
                  <a
                    href="https://www.skedy.life/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("terms")}
                  </a>
                  {t("end")}
                  <a
                    href="https://www.skedy.life/policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("privacy_policy")}
                  </a>
                </span>
              </label>
            </div>
          </section>
        )}
      </>
    );
  },
);

export default UserDetails;
